import { Container, Row } from "reactstrap";
import { GeneralTitle, WidgetTitle } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import TotalSale from "../../dashboards/eCommerce/TotalSale";
import Summary from "../../dashboards/eCommerce/Summary";
import CustomerGrowth from "../../dashboards/eCommerce/CustomerGrowth";
import LatestOfferProduct from "../../dashboards/eCommerce/latestOfferProduct";
import WeeklyUserActivity from "../../dashboards/eCommerce/WeeklyUserActivity";
import RecentStatistics from "../../dashboards/default/RecentStatistics";
import SalesStats from "../../dashboards/default/SalesStats";

const GeneralContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={GeneralTitle} parent={WidgetTitle} />
      <Container fluid className="ecommerce-dashboard">
        <Row>
          <TotalSale />
          <Summary />
          <CustomerGrowth colClass="col-xl-6 proorders-xl-3 box-col-12" />
          <LatestOfferProduct colClass="proorders-xl-5 col-xxl-6" />
          <WeeklyUserActivity colClass="col-lg-6" />
          <RecentStatistics colClass="col-xxl-4 proorders-xl-7 col-lg-6" />
          <SalesStats colClass="col-xxl-4 proorders-xl-4 col-xl-6" />
        </Row>
      </Container>
    </>
  );
};

export default GeneralContainer;
